module.exports = __webpack_public_path__ + "3e5675c89f974f7811eeaf07e2dd5ba3.woff";